import { validationTypes } from "../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../data/formFieldType";


const ResetPasswordData = {
    name: "Login From",
    initialState: { email: "", newPassword: "", confirmPassword: "" },
    section: [
        {
            sectionId: 'basicDetailSection',
            title: "Basic User Details",
            row: {},
            style: {
                sectionStyle: "",
            },
            wrapperTemplate: <div className=" row"></div>,
            fields: [
                {
                    id: "email",
                    label: "Email Address",
                    Field_Name: "Email Address",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "email",
                    fieldSetting: {
                        placeholder: "email",
                        allowSpace: true,
                        isDisable: true
                    },
                    validation: [{ type: "require" }],
                    style: {
                        containerCss: "col-md-12 mb-2 forgot-password-input"
                    }
                },
                {
                    id: "password",
                    label: "Password",
                    Field_Name: "password",
                    fieldType: FormFieldTypes.PASSWORD,
                    dataField: "psPassword360",
                    fieldSetting: {
                        placeholder: "Please Enter Password",
                        allowSpace: true,
                        isDisable: false,
                    },
                    validation: [
                        { type: validationTypes.REQUIRE },
                        { type: validationTypes.PASSWORD },
                    ],
                    style: {
                        containerCss: "col-lg-12 col-md-12 mb-2 forgot-password-input",
                    },
                },
                {
                    id: "psConfirmPassword360",
                    label: "Confirm Password",
                    Field_Name: "confirm password",
                    fieldType: FormFieldTypes.PASSWORD,
                    dataField: "psConfirmPassword360",
                    fieldSetting: {
                        placeholder: "Please Enter Confirm Password",
                        allowSpace: true,
                        isDisable: false,
                    },
                    validation: [
                        { type: validationTypes.REQUIRE },
                        { type: validationTypes.PASSWORD },
                        { type: validationTypes.COMPARE, compareEle: 'psPassword360' }
                    ],
                    style: {
                        containerCss: "col-lg-12 col-md-12 mb-2 forgot-password-input",
                    },
                },
            ],
        }
    ]
};

export default ResetPasswordData;